module.exports = __webpack_public_path__ + "img/auto-check.76f4b616.png";